<template>
  <question-card hide-button>
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <div>
      <answer-icon-block>
        <answer-icon
          @click="answer(false)"
          image="agent_no.svg"
          :checked="questionnaireLead.WorkingWithRealtor === false"
        >
          {{UIComponentData.Choice2.Translations[questionnaireLead.Language]}}
        </answer-icon>
        <answer-icon
          @click="answer(true)"
          image="agent_yes.svg"
          :checked="questionnaireLead.WorkingWithRealtor === true"
        >
          {{UIComponentData.Choice1.Translations[questionnaireLead.Language]}}
        </answer-icon>
      </answer-icon-block>
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import QuestionCard from '@/components/QuestionCard.vue';
import AnswerIcon from '@/components/AnswerIcon.vue';
import AnswerIconBlock from '@/components/AnswerIconBlock.vue';

export default {
  name: 'realtor-step',
  components: {
    QuestionCard,
    AnswerIcon,
    AnswerIconBlock,
  },
  methods: {
    ...mapActions(['mutateLead']),
    async answer(value) {
      this.questionnaireLead.WorkingWithRealtor = value;
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
};
</script>
